export default __webpack_public_path__ + "static/media/enepath.5e01b985.png";